import React from "react";
import { Tabs, Table } from "antd";
import axios from "axios";
import { ANALYSIS_API } from "../../constants/Api";

import Details from "./Details";

const TabPane = Tabs.TabPane;

function callback(key) {
  console.log(key);
}

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(
      `selectedRowKeys: ${selectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
  },
  getCheckboxProps: record => ({})
};

class Grid extends React.Component {
  constructor() {
    super();
    this.state = {
      columns: [
        {
          title: " ",
          dataIndex: "state",
          key: "state",
          width: 32,
          render: () => (
            <img
              onClick={this.toggleDetails}
              src="/img/eye.svg"
              style={{ cursor: "pointer" }}
              alt=""
            />
          )
        },
        {
          title: "CHR",
          dataIndex: "chr",
          key: "chr",
          defaultSortOrder: "descend",
          width: 74,
          sorter: (a, b) => b.chr - a.chr
        },
        {
          title: "Position",
          dataIndex: "position",
          key: "position",
          width: 108,
          sorter: (a, b) => b.position.localeCompare(a.position)
        },
        {
          title: "Variation type",
          dataIndex: "variationType",
          key: "variationType",
          width: 188,
          sorter: (a, b) => b.variationType.localeCompare(a.variationType)
        },
        {
          title: "Gene region",
          dataIndex: "geneRegion",
          key: "geneRegion",
          width: 128,
          sorter: (a, b) => ("" + b.geneRegion).localeCompare(a.geneRegion)
        },
        {
          title: "Gene symbol",
          dataIndex: "geneSymbol",
          key: "geneSymbol",
          width: 128,
          sorter: (a, b) => ("" + b.geneSymbol).localeCompare(a.geneSymbol)
        },
        {
          title: "Protein variant",
          dataIndex: "proteinVariant",
          key: "proteinVariant",
          width: 148,
          sorter: (a, b) => ("" + b.subjectId).localeCompare(a.proteinVariant)
        },
        {
          title: "Variant findings",
          dataIndex: "variantFindings",
          key: "variantFindings",
          width: 154,
          sorter: (a, b) => b.variantFindings.localeCompare(a.variantFindings)
        },
        {
          title: "Case samples",
          dataIndex: "caseSamples",
          key: "caseSamples",
          width: 158,
          sorter: (a, b) => b.caseSamples.localeCompare(a.caseSamples),
          render: value => (
            <div
              className="grid__badge"
              style={{
                background: parseInt(value) === 1 ? "#2284E6" : "#FF922B"
              }}
            />
          )
        },
        {
          title: "Translation impact",
          dataIndex: "translationImpact",
          key: "translationImpact",
          width: 156,
          sorter: (a, b) =>
            b.translationImpact.localeCompare(a.translationImpact)
        }
      ],
      data: null,
      loading: true,
      visibleDetails: false
    };
  }

  componentDidMount() {
    this.setState({ loading: true }, () => {
      axios
        .get(ANALYSIS_API)
        .then(response => {
          this.setState({ data: response.data, loading: false });
          // console.log(this.state.data);
        })
        .catch(error => {
          console.log(error);
          this.setState({ loading: false });
        });
    });
  }

  toggleDetails = () => {
    this.setState({
      visibleDetails: !this.state.visibleDetails
    });
  };

  render() {
    const { columns, data, loading, visibleDetails } = this.state;
    return (
      <div className="grid">
        <Tabs onChange={callback} defaultActiveKey="2" type="card">
          <TabPane tab="Summary" key="1">
            Content of Summary
          </TabPane>
          <TabPane tab="Variants" key="2">
            <div className="grid__head">
              <div className="grid__title">24 Variants</div>
              <div className="grid__filters">
                Filters applied <span className="grid__counter">0</span>
              </div>
            </div>
            <div
              className={"grid__body " + (visibleDetails ? "show-details" : "")}
            >
              <div className="grid__scroll">
                <Table
                  className="grid__table"
                  rowSelection={rowSelection}
                  columns={columns}
                  dataSource={data}
                  pagination={false}
                  loading={loading}
                  size="small"
                />
              </div>
              {visibleDetails && <Details />}
            </div>
          </TabPane>
          <TabPane tab="Genes" key="3">
            Content of Genes
          </TabPane>
          <TabPane tab="Groups/Complexes" key="4">
            Content of Groups/Complexes
          </TabPane>
          <TabPane tab="Pathways" key="5">
            Content of Pathways
          </TabPane>
          <TabPane tab="Processes" key="6">
            Content of Processes
          </TabPane>
          <TabPane tab="Diseases" key="7">
            Content of Diseases
          </TabPane>
          <TabPane tab="Overview" key="8">
            Content of Overview
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default Grid;
